module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_13_4.19bb4ebd.jpeg";